
import LoginForm from './components/LoginForm'
import RegisterForm from './components/RegisterForm'
import MarginBox from '../../shared/components/other/MarginBox';
import { useState } from 'react';
import Navbar from '../../shared/components/navbar/NavBar';

export default function Login({ registerPage = false }) {

  const [isRegister, setIsRegister] = useState(registerPage)

  const lForm = isRegister ? <RegisterForm isRegister={isRegister} setIsRegister={setIsRegister} /> : <LoginForm isRegister={isRegister} setIsRegister={setIsRegister} />

  return (
    <MarginBox wrapperClassName="loginWrapper">
      <Navbar/>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: "url('/registration.svg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          filter: 'blur(10px)',
          zIndex: 0
        }}
      />
      {lForm}
    </MarginBox>
  );
}
